<div class="flex flex-col gap-6 animate-in fade-in duration-500">
    <!-- Search and Actions -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 bg-white rounded-2xl shadow-sm border border-slate-100">
        <div class="w-full sm:max-w-md">
            <p-iconField iconPosition="left" class="w-full">
                <p-inputIcon styleClass="pi pi-search text-slate-400" />
                <input 
                    type="text" 
                    pInputText 
                    [(ngModel)]="searchText" 
                    (input)="onSearch(searchText)" 
                    [placeholder]="'SEARCH' | translate"
                    class="w-full !rounded-xl !py-2.5 !pl-10 !bg-slate-50 !border-none focus:!ring-2 focus:!ring-primary/10 transition-all">
            </p-iconField>
        </div>
        <div class="flex items-center gap-6 w-full sm:w-auto justify-end">
            <div class="flex items-center gap-3 px-2">
                <span class="text-[10px] font-black text-slate-400 uppercase tracking-widest">{{ 'SHOW_INACTIVE' | translate }}</span>
                <p-toggleSwitch [(ngModel)]="showInactive" (onChange)="onSearch(searchText)"></p-toggleSwitch>
            </div>
            
            <app-button *hasPermission="'Salas:create'"
                [label]="'rooms_new_title' | translate"
                icon="pi pi-plus"
                (onClick)="openNewRoom()"
                variant="primary"
                class="w-full sm:w-auto">
            </app-button>
        </div>
    </div>

    <!-- Table Section -->
    <div class="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden min-h-[500px] flex flex-col">
        <app-prime-table
            [columns]="cols"
            [data]="rooms"
            [loading]="loading"
            [paginator]="totalRecords > pageSize"
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [lazy]="true"
            (onLazyLoad)="onLazyLoad($event)"
            [templates]="{ 
                status: statusTemplate, 
                actions: actionsTemplate
            }"
            class="flex-1">
        </app-prime-table>
    </div>
</div>

<!-- Custom Templates -->
<ng-template #statusTemplate let-row>
    <button (click)="toggleStatus(row)" 
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-black uppercase tracking-widest transition-all hover:scale-105 active:scale-95"
            [ngClass]="row.active !== false ? 'bg-emerald-50 text-emerald-600' : 'bg-rose-50 text-rose-600'">
        {{ (row.active !== false ? 'status_active' : 'status_inactive') | translate }}
    </button>
</ng-template>

<ng-template #actionsTemplate let-row>
    <div class="flex justify-center">
        <app-dropdown *hasPermission="'Salas:edit'">
            <ng-template #trigger>
                <button class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all" [title]="'actions' | translate">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
                    </svg>
                </button>
            </ng-template>
            <ng-template #content>
                <div class="flex flex-col min-w-[200px]">
                    <button *hasPermission="'Salas:edit'" (click)="openEdit(row)"
                            class="w-full text-left px-4 py-3 text-xs font-black text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors uppercase tracking-widest group/edit">
                        <i class="pi pi-pencil text-primary text-base transition-transform group-hover/edit:scale-110"></i>
                        {{ 'EDIT' | translate }}
                    </button>

                    <ng-container *hasPermission="'Salas:edit'">
                    <button *ngIf="row.active === false" (click)="toggleStatus(row)"
                            class="w-full text-left px-4 py-3 text-xs font-black text-emerald-600 hover:bg-emerald-50 flex items-center gap-3 transition-colors uppercase tracking-widest group/activate">
                        <i class="pi pi-check-circle text-emerald-600 text-base transition-transform group-hover/activate:scale-110"></i>
                        {{ 'ACTIVATE' | translate }}
                    </button>

                    <button *ngIf="row.active !== false" (click)="toggleStatus(row)"
                            class="w-full text-left px-4 py-3 text-xs font-black text-rose-500 hover:bg-rose-50 flex items-center gap-3 transition-colors uppercase tracking-widest group/deactivate">
                        <i class="pi pi-times-circle text-rose-500 text-base transition-transform group-hover/deactivate:scale-110"></i>
                        {{ 'DEACTIVATE' | translate }}
                    </button>
                    </ng-container>
                </div>
            </ng-template>
        </app-dropdown>
    </div>
</ng-template>

<!-- Form Modal (Unified New/Edit) -->
<app-room-form-modal 
    *ngIf="showNewRoom || editingRoom" 
    [room]="editingRoom" 
    (close)="showNewRoom = false; editingRoom = null"
    (saved)="onNewRoomSuccess()">
</app-room-form-modal>
<p-confirmDialog 
    styleClass="premium-confirm-dialog" 
    [baseZIndex]="20000" 
    acceptButtonStyleClass="!bg-rose-500 !border-rose-500 !rounded-xl !px-6 !text-white" 
    rejectButtonStyleClass="p-button-text !rounded-xl !px-6 !text-slate-400">
</p-confirmDialog>
